import styled from 'styled-components'
import Menu from '@material-ui/core/Menu'
import { DrawerListItem } from '../'
import React from "react";
import { tokens } from '../../../assets/tokens'
import { safeAlpha } from '../../../utils/color'

// Menú desplegable con el estilo de los menús de Velora: papel blanco con radio 8, items de 40 px
// en 14/400 e iconos de 18 px en trazo; el seleccionado con el tinte del color del cliente
export const MenuContainer = styled(props => <Menu {...props}/>)`
  .MuiMenu-paper {
    min-width: 220px;
    margin-top: 4px;
    border-radius: 8px;
    box-shadow: ${tokens.shadow.card};
  }
  .MuiList-root {
    padding: 4px 0;
  }
`
export const Item = styled(props => <DrawerListItem {...props}/>)`
  && {
    height: 40px;
    margin: 2px 6px;
    width: calc(100% - 12px);
    padding: 0 12px;
    border-radius: 6px;

    :hover {
      background-color: ${tokens.color.background.light};
    }

    &.Mui-selected,
    &.Mui-selected:hover {
      background-color: ${props => safeAlpha(props.theme.primary, 0.12)};
    }
  }

  .MuiListItemIcon-root {
    min-width: 28px;

    svg {
      width: 18px;
      height: 18px;
      color: ${tokens.color.text.tertiary};
    }
  }

  .MuiListItemText-root span {
    font-family: ${tokens.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${tokens.color.text.secondary};
  }

  /* Opciones con punto de color (selector de estado de las fichas de procesos y feedback) */
  .status-option {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .status-option-dot {
    flex-shrink: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  &.Mui-selected .MuiListItemText-root span {
    font-weight: 500;
    color: ${tokens.color.text.primary};
  }

  & span.MuiTouchRipple-root {
    ${props => props.backgroundColorRow ? '' +
      'border-right: 5px solid ' + props.backgroundColorRow+';' +
      'background-color: ' + props.backgroundColorRow+'0c;'
    : ''};
  }

  div {
    text-align: left;
  }
`
